<template>
  <f7-page id="page-account-my-coupon" name="account-my-coupon" @page:afterin="afterin">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block class="mt-xxl mb-xxl">
      <p class="wandr-title-1 fw-bold">{{$t('general-text-my-coupons')}}</p>
      <div v-for="cp in couponList" :key="cp.code" class="my-coupon-list">
        <div><img :src="require('@/assets/img/icon/icon-coupon.svg')" class="vertical-align-middle" /></div>
        <div class="ml-20">
          <div class="wandr-subtitle-2">{{cp.amount}} {{cp.currencyCode}} {{$t('sendmoney-text-offer')}}</div>
          <div class="text-color-gray">{{$t('sendmoney-text-valid-until')}} {{cp.validdate}}</div>
        </div>
      </div>

      <div v-show="showEmptyCoupon" class="wandre-box text-color-gray fs-14 fw-medium">
        <span>{{$t('account-coupon-empty')}}</span><br />
        <span v-html="$t('account-coupon-empty2')"></span>
        <hr class="my-3" style='border-color: rgba(var(--f7-color-neutral-gray-30-rgb), 0.5);'/>
        <div class="d-flex align-items-center justify-content-evenly">
          <a href="https://www.facebook.com/profile.php?id=100087867352907" class="external" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-facebook@2x.png')" width="40" height="40"/></div></a>
          <a href="https://www.instagram.com/wandre_sg" class="external" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-instagram@2x.png')" width="40" height="40"/></div></a>
          <a href="https://twitter.com/wandr_e_" class="external" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-twitter@2x.png')" width="40" height="40"/></div></a>
          <a href="https://www.linkedin.com/company/wandr-e/about/" class="external" target="_blank"><div class="d-flex justify-content-center align-items-center bg-color-white rounded-circle" style="padding: 4px;"><img :src="require('@/assets/img/icon/sm-linkedin@2x.png')" width="40" height="40"/></div></a>
        </div>
      </div>

    </f7-block>

  </f7-page>
</template>

<script>
  export default {
    data() {
			return {
        couponList : [],
        showEmptyCoupon : false,
			}
		},
    mounted(){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      this.getCouponList()
    },
    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      getCouponList(){
        const self = this
        self.showPreloader()
        const couponDiscount = this.$api.transaction.getDiscountList(0)
        self.couponList = []
        couponDiscount.then(function(result) {
          if(result.length > 0){
            Object.keys(result).forEach(function(key) {
              var val = result[key]
              var coupon  = []
              coupon["code"] = val.couponCode
              coupon["currencyCode"] = val.discount.currencyCode
              coupon["percent"] = val.discount.percent
              coupon["amount"] = val.discount.value
              coupon["discountCampaignDescription"] = val.discountCampaignDescription
              coupon["discountCampaignName"] = val.discountCampaignName
              coupon["validdate"] = self.getDateFormat(val.endDate, false)
              self.couponList.push(coupon)
            })
          }else{
            self.showEmptyCoupon = true
          }
          self.hidePreloader()
        })
      },

      backButton(){
        this.$f7router.back({ transition: 'f7-push' })
      }
    }
  }
</script>